/* ROV — lightweight interactions: scroll reveal + sticky buy bar. No deps. */
(function () {
  "use strict";

  // Reveal on scroll
  function initReveal() {
    var els = document.querySelectorAll(".rov-reveal");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el, i) {
      el.style.transitionDelay = (Math.min(i % 4, 3) * 0.06) + "s";
      io.observe(el);
    });
  }

  // Sticky buy bar: show after hero scrolls out, hide near footer
  function initSticky() {
    var bar = document.querySelector(".rov-sticky");
    if (!bar) return;
    var anchor = document.querySelector("[data-rov-hero]") || document.querySelector(".rov-hero");
    var footer = document.querySelector(".rov-cta, footer, .footer");
    function update() {
      var trigger = anchor ? anchor.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      var nearEnd = false;
      if (footer) {
        var r = footer.getBoundingClientRect();
        nearEnd = r.top < window.innerHeight - 40;
      }
      bar.classList.toggle("is-on", trigger && !nearEnd);
    }
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
  }

  // Cart line items are few and above the fold: load their thumbnails eagerly
  // so the first paint never shows an empty square while lazy-load catches up
  // (cart page, cart notification popup and cart drawer all match).
  function eagerLoadCartImages(root) {
    var imgs = (root || document).querySelectorAll(
      ".cart-item img[loading='lazy'], .cart-notification-product img[loading='lazy'], .drawer__cart-item img[loading='lazy']"
    );
    imgs.forEach(function (img) {
      img.loading = "eager";
      img.setAttribute("fetchpriority", "high");
    });
  }

  function initCartImages() {
    eagerLoadCartImages();
    if (!("MutationObserver" in window)) return;
    var mo = new MutationObserver(function () { eagerLoadCartImages(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () { initReveal(); initSticky(); initCartImages(); });
})();
